"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
function create(method, params = [], id, targetChain) {
    const payload = {
        id, method, params, jsonrpc: '2.0'
    };
    if (targetChain) {
        payload.chainId = targetChain;
    }
    if (payload.method === 'eth_sendTransaction') {
        const mismatchedChain = isChainMismatch(payload);
        if (mismatchedChain) {
            throw new Error(`Payload chainId (${mismatchedChain}) inconsistent with specified target chainId: ${targetChain}`);
        }
        return updatePayloadChain(payload);
    }
    return payload;
}
exports.create = create;
function isChainMismatch(payload) {
    if (payload.method !== 'eth_sendTransaction')
        return false;
    const tx = payload.params[0] || {};
    const chainId = tx.chainId;
    return ('chainId' in tx) && parseInt(chainId) !== parseInt(payload.chainId || chainId);
}
function updatePayloadChain(payload) {
    const tx = payload.params[0] || {};
    return { ...payload, params: [{ ...tx, chainId: tx.chainId || payload.chainId }, ...payload.params.slice(1)] };
}
